<div class="modal-content extras-modal">
    <div class="modal-header">
        <p class="title-extras-modal">{{ title }}</p>
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
    <div class="modal-body p-3">
      <p class="message-modal-extras">{{ message }}</p>
    </div>
  
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="closeModal()">{{'EXTRAS_PAGE.MODAL_BUTTON'  | translate   }}</button>
    </div>
  </div>